// extracted by mini-css-extract-plugin
export default {"container":"FiZ75KTHE20yN4OPWMCQ","pictureContainer":"lVFHS8ALfDRIJgpdb64p","picture":"al3zEA1b74y03vfRGEOw","name":"sm6LDYQI5lV2cSpmAL16","location":"_nYH_Mj3mDeqvdwAFNG5"};